/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    progressBarContainer: {
        width: '100%',
        height: '4px',
        backgroundColor: tokens.colorNeutralBackground3,
        borderRadius: '2px',
        overflow: 'hidden',
        marginBottom: '8px'
    },
    progressBar: {
        height: '100%',
        backgroundColor: tokens.colorBrandBackground,
        borderRadius: '2px',
        transition: 'width 0.3s ease-in-out'
    },
    progressValue: {
        textAlign: 'center',
        fontWeight: '400',
        paddingBottom: '8px',
        fontSize: '12px',
        lineHeight: '16px'
    }
});
